<div class="flex flex-col w-full max-w-[300px] h-full overflow-hidden rounded-xl border border-gray-200 shadow-sm bg-white">

    <div class="w-full aspect-[9/16] bg-pet-gray-1 flex items-center justify-center overflow-hidden">
        <img [src]="publicidad.ubicacion" [alt]="publicidad.nombre" class="w-full h-full object-contain" />
    </div>

    <div class="flex flex-col gap-2 p-4">
        <p class="text-sm font-bold text-pet-color-text-1 truncate">{{ publicidad.nombre }}</p>

        <div *ngIf="publicidad.facebook || publicidad.instagram" class="flex flex-wrap gap-2">
            <a *ngIf="publicidad.facebook" [href]="publicidad.facebook" target="_blank" rel="noopener noreferrer"
                aria-label="Facebook de {{ publicidad.nombre }}"
                class="flex items-center gap-1 px-3 py-1 rounded-full border border-gray-300 text-xs text-pet-color-text-1 hover:border-pet-color-5 hover:text-pet-color-5 transition-colors">
                <img src="assets/images/facebookicon.png" alt="" class="h-4">
                Facebook
            </a>
            <a *ngIf="publicidad.instagram" [href]="publicidad.instagram" target="_blank" rel="noopener noreferrer"
                aria-label="Instagram de {{ publicidad.nombre }}"
                class="flex items-center gap-1 px-3 py-1 rounded-full border border-gray-300 text-xs text-pet-color-text-1 hover:border-pet-color-5 hover:text-pet-color-5 transition-colors">
                <img src="assets/images/icon-instagram.png" alt="" class="h-4">
                Instagram
            </a>
        </div>
    </div>

</div>